import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errMsg, fmtDate, money } from "@/lib/api";

const Head = ({ cols }) => <TableHeader><TableRow className="border-white/5">{cols.map((c) => <TableHead key={c} className="text-zinc-500">{c}</TableHead>)}</TableRow></TableHeader>;

export const BusinessesAdmin = () => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/businesses").then(({ data }) => setRows(data)), []);
  useEffect(() => { load(); }, [load]);
  const set = async (id, status) => {
    try { await api.post(`/admin/businesses/${id}/status`, { status }); toast.success(`Business ${status}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="lux-card overflow-x-auto" data-testid="businesses-admin">
      <Table><Head cols={["Store", "Contact", "Address", "Deliveries", "Status", "Action"]} />
        <TableBody>{rows.map((b) => (
          <TableRow key={b.id} data-testid={`business-row-${b.id}`} className="border-white/5">
            <TableCell className="text-amber-100">{b.business_name}</TableCell>
            <TableCell className="text-xs text-zinc-400">{b.contact_name}<br />{b.email} · {b.phone}</TableCell>
            <TableCell className="text-xs text-zinc-400">{b.store_address?.address}</TableCell>
            <TableCell>{b.deliveries}</TableCell>
            <TableCell data-testid={`business-status-${b.id}`} className="capitalize">{b.status}</TableCell>
            <TableCell className="space-x-2 whitespace-nowrap">
              {b.status !== "approved" && <button data-testid={`business-approve-${b.id}`} onClick={() => set(b.id, "approved")} className="btn-gold !px-3 !py-1.5 text-xs">Approve</button>}
              {b.status === "approved" && <button data-testid={`business-suspend-${b.id}`} onClick={() => set(b.id, "suspended")} className="btn-danger !px-3 !py-1.5 text-xs">Suspend</button>}
            </TableCell>
          </TableRow>
        ))}</TableBody>
      </Table>
    </div>
  );
};

export const DeliveriesAdmin = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/deliveries").then(({ data }) => setRows(data)); }, []);
  return (
    <div className="lux-card overflow-x-auto" data-testid="deliveries-admin">
      <Table><Head cols={["Created", "Store", "Customer", "Items", "Driver", "Status", "Fee", "Payment"]} />
        <TableBody>{rows.map((d) => (
          <TableRow key={d.id} data-testid={`admin-delivery-row-${d.id}`} className="border-white/5">
            <TableCell className="text-xs text-zinc-400">{fmtDate(d.created_at)}</TableCell>
            <TableCell className="text-amber-100">{d.business_name}</TableCell>
            <TableCell className="text-xs">{d.customer_name}<br /><span className="text-zinc-500">{d.customer_email}</span></TableCell>
            <TableCell className="max-w-[220px] truncate text-xs text-zinc-400">{d.items}</TableCell>
            <TableCell className="text-xs">{d.driver_name || "—"}</TableCell>
            <TableCell className="text-xs" data-testid={`admin-delivery-status-${d.id}`}>{d.status_label}</TableCell>
            <TableCell>{money(d.total)}</TableCell>
            <TableCell className="text-xs text-zinc-400">{d.refunded ? "Refunded" : d.paid ? `Paid (${d.payment_method === "card_on_file" ? "card on file" : "link"})` : "Unpaid"}</TableCell>
          </TableRow>
        ))}</TableBody>
      </Table>
    </div>
  );
};
